import { BaseDriver } from '@wix/wix-ui-test-utils/driver-factory';

export interface BreadcrumbsDriver extends BaseDriver {
  breadcrumbsLength: () => number;
  breadcrumbContentAt: (position: number) => string | null;
  clickBreadcrumbAt: (position: number) => any;
  getActiveItemId: () => number | null;
  isLarge: () => boolean;
  isMedium: () => boolean;
  isSmall: () => boolean;
  isOnWhiteBackground: () => boolean;
  isOnGrayBackground: () => boolean;
  isOnDarkBackground: () => boolean;
  isActiveLinkAt: (index: number) => boolean;
}
